import { ProductSortMode } from 'types'

const norm = (v: unknown) =>
  String(v ?? '')
    .trim()
    .toLowerCase()

const getCategory = (p: any) => norm(p?.category_name ?? p?.category ?? p?.categoryName)

const getSubcategory = (p: any) => norm(p?.subcategory ?? '')

const getStartDate = (p: any): string => {
  // Try startDate first, then dateRange[0]
  const date = p?.startDate ?? p?.dateRange?.[0] ?? ''
  return String(date).trim()
}

export const sortProducts = (rows: any[], mode: ProductSortMode) => {
  const withIdx = rows.map((r, i) => ({ r, i })) // stable tie-breaker
  const cmp = (a: any, b: any) => (a < b ? -1 : a > b ? 1 : 0)

  withIdx.sort((A, B) => {
    const a = A.r
    const b = B.r

    const nameA = norm(a?.productName ?? a?.title ?? a?.name)
    const nameB = norm(b?.productName ?? b?.title ?? b?.name)

    const catA = getCategory(a)
    const catB = getCategory(b)

    const dateA = getStartDate(a)
    const dateB = getStartDate(b)

    const subA = getSubcategory(a)
    const subB = getSubcategory(b)

    let res = 0

    switch (mode) {
      case 'NAME_CATEGORY_ASC':
        res = cmp(nameA, nameB) || cmp(catA, catB)
        break
      case 'CATEGORY_NAME_ASC':
        res = cmp(catA, catB) || cmp(nameA, nameB)
        break
      case 'NAME_ASC':
        res = cmp(nameA, nameB)
        break
      case 'NAME_DESC':
        res = cmp(nameB, nameA)
        break
      case 'DATE_ASC':
        res = cmp(dateA, dateB) || cmp(nameA, nameB)
        break
      case 'DATE_DESC':
        res = cmp(dateB, dateA) || cmp(nameA, nameB)
        break
      case 'CATEGORY_ASC':
        res = cmp(catA, catB) || cmp(subA, subB) || cmp(nameA, nameB)
        break
      case 'CATEGORY_DESC':
        res = cmp(catB, catA) || cmp(subB, subA) || cmp(nameA, nameB)
        break
      case 'SUBCATEGORY_ASC':
        res = cmp(subA, subB) || cmp(catA, catB) || cmp(nameA, nameB)
        break
      case 'SUBCATEGORY_DESC':
        res = cmp(subB, subA) || cmp(catB, catA) || cmp(nameA, nameB)
        break
    }

    // stable fallback (keeps original relative order for ties)
    return res || A.i - B.i
  })

  return withIdx.map(x => x.r)
}
